import { MessageCircle } from "lucide-react";
import { SCHOOL } from "@/lib/site";

export default function WhatsAppButton() {
  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/${SCHOOL.whatsapp}?text=${encodeURIComponent("Hello Royal English High School, I would like to know more about admissions.")}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <div className="w-16 h-16 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center shadow-2xl whatsapp-pulse">
        <MessageCircle size={28} />
      </div>
      <span className="absolute right-20 top-1/2 -translate-y-1/2 bg-royal text-white px-4 py-2 rounded-full font-semibold text-sm shadow-xl opacity-0 group-hover:opacity-100 transition-all whitespace-nowrap">
        Chat on WhatsApp
      </span>
    </a>
  );
}
